import React, { useState, useMemo, useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import SendToMessenger from "../../../desktop/pages/details/module/send-to-messenger";
import SendToWhatsapp from "./send-to-whatsapp";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { fetchGetMessage } from "../../../../api";

const SubscribeWarpped = props =>{
    const { country, customer, phoneNumber = "" } = props;
    const global = useSelector(state=>state.global);
    const [supportCountrys, setSupportCountrys] = useState(null);

    useEffect(async () =>{
        let response = await fetchGetMessage("M1793");
        if(response?.code === 200 && response?.result?.message){
            setSupportCountrys(response.result.message.split(","));
        }
    }, []);

    const supportWhatsApp = useMemo(() =>{
        if(!!global.config?.support?.whatsapp && supportCountrys?.length > 0 && country){
            return supportCountrys.includes(country);
        }

        return false;
    }, [country, supportCountrys, global.config?.support]);

    return <div className={`${cls.SubscribeCnotainer} ${props?.className?props.className:''}`}>
        <div className={cls.Message}><FormattedMessage id="send_subscribe_message" values={{ website: global?.config?.name }} defaultMessage="Click to agree promotional messages from {website} via WhatsApp or messenger!  You can unsubscribe at any point." /></div>

        <div className={cls.SendContainer}>
            {
                !customer.subscribeToFacebookMessage && <div className={cls.MessengerItem}>
                    <SendToMessenger 
                        customerId={customer.id} 
                        messengerSize="small" 
                    />
                </div>
            }
            
            {
                supportWhatsApp && !customer?.subscribeToWhatsApp && <div className={cls.WhatsAppItem}>
                    <SendToWhatsapp country={country} phoneNumber={phoneNumber} />
                </div>
            }
        </div>
    </div>
}

export default props =>{
    useStyles(cls);
    const { customer } = props;

    // const [showMsg, setShowMsg] = useState(false);

    // const checkBoxCallback = useCallback((checkBoxStatus) =>{
    //     console.log('checkBoxStatus', checkBoxStatus)
    //     if(checkBoxStatus === "rendered"){
    //         setShowMsg(true);
    //     }else if(checkBoxStatus === "hidden"){
    //         setShowMsg(false);
    //     }
    // }, [customer]);

    

    return <React.Fragment>
        {
            (!customer?.subscribeToWhatsApp || !customer?.subscribeToFacebookMessage) && <React.Fragment>
                <SubscribeWarpped {...props} />
            </React.Fragment>
        }
    </React.Fragment>
}